import React from 'react';
import BusinessListingPreviewPanel, {
  type BusinessListingPreviewProps,
} from './BusinessListingPreviewPanel';

type WizardPreviewLayoutProps = {
  children: React.ReactNode;
  preview: BusinessListingPreviewProps['preview'];
  renderPreview?: BusinessListingPreviewProps['renderVisual'];
  showPreview?: boolean;
};

/**
 * Two-column wizard layout: form on the left, live app preview on the right.
 * On smaller screens the preview stacks below the form.
 */
const WizardPreviewLayout: React.FC<WizardPreviewLayoutProps> = ({
  children,
  preview,
  renderPreview,
  showPreview = true,
}) => {
  if (!showPreview) {
    return <>{children}</>;
  }

  return (
    <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_300px] lg:items-start xl:grid-cols-[minmax(0,1fr)_320px]">
      <div className="min-w-0">{children}</div>
      <div className="lg:sticky lg:top-24">
        <BusinessListingPreviewPanel preview={preview} renderVisual={renderPreview} />
      </div>
    </div>
  );
};

export default WizardPreviewLayout;
